import { createSelector } from 'reselect';
import { selectActiveComponentIndex } from './search.selector';
import { getFilterListByType, mapCarShipCodeCategory } from '../../utils/car.utils';
import {
  orderByAsc,
  orderByAscWithParse,
  orderByDesc,
  orderByDescWithParse,
} from '../../utils/filter.utils';
import { selectCompanyCurrency, selectCompanyCurrencyCulture } from './auth.selector';

export const selectCarFeatureState = (state) => state?.car;

export const selectCarComponents = createSelector(
  selectCarFeatureState,
  (state) => state && state.components
);

export const selectedCarComponents = createSelector(selectCarComponents, (state) => {
  const keys = Object.keys(state);
  const selectedCars = [];
  keys.map((res) => {
    selectedCars.push(state[res].selectedCar);
  });
  return state && selectedCars;
});

export const selectedCarComponentForPurchase = createSelector(selectCarComponents, (state) => {
  const key = Object.keys(state)[0];
  if (key !== undefined) {
    return state && state[key]?.selectedCar;
  } else {
    return '';
  }
});
export const selectActiveCarComponent = createSelector(
  selectCarComponents,
  selectActiveComponentIndex,
  (state, displayIndex) => state && state[displayIndex]
);

export const selectCarSearchResults = createSelector(
  selectActiveCarComponent,
  (state) => state?.searchResults
);

export const selectCarShipCodeCategory = createSelector(selectCarSearchResults, (state) =>
  mapCarShipCodeCategory(state?.CarTypeList)
);

export const selectCarResponses = createSelector(selectCarSearchResults, (state) => state?.Cars);

export const selectCarSearchType = createSelector(
  selectActiveCarComponent,
  (state) => state?.filterBySearchType
);

export const selectCarFilterByDetails = createSelector(
  selectActiveCarComponent,
  (state) => state?.filterByDetails
);

export const selectCarOrderBy = createSelector(selectActiveCarComponent, (state) => state?.orderBy);

export const selectCarOrderByReverse = createSelector(
  selectActiveCarComponent,
  (state) => state?.reverse
);

export const selectCarFilterListBySearchType = createSelector(
  selectActiveCarComponent,
  (state) => state?.filterListBySearchType
);

export const selectCarFilterByType = createSelector(
  selectActiveCarComponent,
  (state) => state?.filterByType
);

export const selectCarResponsesBySearchType = createSelector(
  selectCarResponses,
  selectCarSearchType,
  (state, searchType) => {
    if (state && searchType) {
      return state.filter((car) => car.RequestType === searchType);
    }

    return state;
  }
);

export const selectCarsFilterByDetails = createSelector(
  selectCarResponsesBySearchType,
  selectCarFilterByDetails,
  (state, filterByDetails) => {
    if (state && filterByDetails) {
      const category = filterByDetails.category;
      const company = filterByDetails.company;

      return state.filter(
        ({ Class, VendorCode }) => category[Class]?.checked && company[VendorCode]?.checked
      );
    }

    return state;
  }
);

export const selectCarFilterListByType = createSelector(
  selectCarsFilterByDetails,
  selectCarShipCodeCategory,
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
  (state, carShipCodeCategory, currency, currencyCulture) =>
    getFilterListByType(state, carShipCodeCategory, currency, currencyCulture)
);

export const selectCarsFilterByType = createSelector(
  selectCarsFilterByDetails,
  selectCarFilterByType,
  (state, filterByType) => {
    if (state && filterByType && filterByType !== 'ALL') {
      return state.filter((i) => i.Class === filterByType);
    }

    return state;
  }
);

export const selectCarResponsesFiltered = createSelector(
  selectCarsFilterByType,
  selectCarOrderBy,
  selectCarOrderByReverse,
  (state, orderBy, reverse) => {
    if (state && orderBy) {
      if (orderBy === 'Class' || orderBy === 'VendorName') {
        if (reverse) {
          return state.slice().sort((a, b) => orderByAsc(a[orderBy], b[orderBy]));
        } else {
          return state.slice().sort((a, b) => orderByDesc(a[orderBy], b[orderBy]));
        }
      } else {
        if (reverse) {
          return state.slice().sort((a, b) => orderByAscWithParse(a[orderBy], b[orderBy]));
        } else {
          return state.slice().sort((a, b) => orderByDescWithParse(a[orderBy], b[orderBy]));
        }
      }
    }

    return state;
  }
);

export const selectCarMapResponses = createSelector(selectCarResponsesFiltered, (state) => {
  if (!state) {
    return state;
  }

  const mapResponse = state.reduce((unique, o) => {
    if (!unique.some((obj) => obj.VendorCode === o.VendorCode)) {
      unique.push(o);
    }
    return unique;
  }, []);

  return mapResponse;
});

export const selectCenterCarPosition = createSelector(selectCarResponsesFiltered, (state) => {
  if (!state) {
    return state;
  } else if (state.length === 0) {
    return {
      latitude: 0,
      longitude: 0,
    };
  }

  const res = state[0].MapInfo.split('|');

  return {
    latitude: Number(res[0]),
    longitude: Number(res[1]),
  };
});
